import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useLanguage } from "../../../../Translations/LenguageContext";
import ErrorMessage from "../../../../Components/ErrorMessage";
import Spinner from "../../../../Components/Spinner";
import { instance } from "three/src/nodes/TSL.js";
import { CiGlobe } from "react-icons/ci";
import { BiPlus } from "react-icons/bi";

const NewFirewallRuleModal = ({ show, handleClose, fetchRecordsFirewall, instanceData }) => {
    const { t } = useLanguage();
    const user_id = sessionStorage.getItem("user_id");
    const { project_id, db_id } = useParams();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({ message: "", display: false });
    const [firewallRules, setFirewallRules] = useState([{ start_ip: "", end_ip: "" }]);

    const CloseModal = () => {
        handleClose();
        setError({ message: "", display: false });
        setFirewallRules([{ start_ip: "", end_ip: "" }]);
    };

    const handleFirewallChange = (index, field, value) => {
        const newRules = [...firewallRules];
        newRules[index][field] = value;
        setFirewallRules(newRules);
    };

    const addFirewallRule = () => {
        setFirewallRules([...firewallRules, { start_ip: "", end_ip: "" }]);
    };

    const removeFirewallRule = (index) => {
        if (firewallRules.length > 1) {
            const newRules = [...firewallRules];
            newRules.splice(index, 1);
            setFirewallRules(newRules);
        }
    };

    const isValidIP = (ip) => {
        const ipRegex = /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;
        return ipRegex.test(ip);
    };

    const handleSaveRules = async () => {
        for (const rule of firewallRules) {
            if (!rule.start_ip || !rule.end_ip) {
                setError({ message: "All firewall rules must have start and end IPs", display: true });
                return;
            }
            if (!isValidIP(rule.start_ip) || !isValidIP(rule.end_ip)) {
                setError({ message: `Invalid IP address detected: ${rule.start_ip} - ${rule.end_ip}`, display: true });
                return;
            }
        }

        setLoading(true);
        setError({ message: "", display: false });

        try {
            const response = await fetch("https://backend.erioon.com/new_firewall_rules", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    user_id: user_id,
                    instance_id: instanceData._id,
                    firewall_rules: firewallRules
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                setError({ message: data.error || "Failed to save firewall rules", display: true });
            } else {
                CloseModal();
                fetchRecordsFirewall();
            }
        } catch (err) {
            setError({ message: err.message || "Network error", display: true });
        } finally {
            setLoading(false);
        }
    };

    const AllowFromAnywhere = () =>{
        setFirewallRules([{ start_ip: "0.0.0.0", end_ip: "255.255.255.255" }]);
    }


    return (
        <Modal show={show} onHide={CloseModal} className="modal_share">
            <div className="share_main_cont_modal">
                <p className="share_label">Create and manage firewall rules </p>
                <p className="share_label_desc">Create a firewall rule for instance {instanceData.instance_name}</p>
                <div className="firewall_btn_cont">
                    <button className="add_rule_btn" onClick={addFirewallRule}>
                        <BiPlus/> Add Rule
                    </button>
                    <button className="add_rule_btn" onClick={AllowFromAnywhere}>
                        <CiGlobe/> Allow from anywhere
                    </button>
                </div>
                {firewallRules.map((rule, i) => (
                    <div key={i} className="firewall_settings_row">
                        <input
                            className="api_name_input"
                            placeholder="Start IP"
                            value={rule.start_ip}
                            onChange={(e) => handleFirewallChange(i, "start_ip", e.target.value)}
                        />
                        <input
                            className="api_name_input"
                            placeholder="End IP"
                            value={rule.end_ip}
                            onChange={(e) => handleFirewallChange(i, "end_ip", e.target.value)}
                        />
                        <button
                            className="remove_row_btn"
                            onClick={() => removeFirewallRule(i)}
                            disabled={firewallRules.length === 1}
                        >
                            x
                        </button>
                    </div>
                ))}

            </div>

            <div className="modal_footer">
                <ErrorMessage err={error} />
                <div className="footer_btn_cont">
                    <button
                        className="save_btn"
                        onClick={handleSaveRules}
                        disabled={loading}
                    >
                        {loading ? <Spinner loading={loading} /> : t.save + " rules"}
                    </button>
                    <button className="cancel_btn" onClick={CloseModal}>
                        {t.cancel}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default NewFirewallRuleModal;
